import React from 'react';
import {FaAngleLeft} from "react-icons/fa6";
import {FaAngleRight} from "react-icons/fa";

const PanelDefault = ({children, show, setShow, btnClassName = [] , className = []}) => {

    return (
        <div className={[`p-4 w-62.5 absolute top-0 left-0 h-screen bg-white shadow-lg transform transition-transform duration-300 ease-in-out ${show ? 'translate-x-0' : '-translate-x-full'}`, className].join(" ")}>
            <span className={[`flex items-center justify-center rounded absolute top-5 z-1 p-[0.15rem] outline-none w-6.25 h-6.25 cursor-pointer bg-[rgba(255,255,255,0.9)] bg-no-repeat bg-[length:7px_10px] bg-[position:7px_center] shadow-[3px_1px_10px_-3px_rgba(0,0,0,0.3)] border border-[#0000003d]`, btnClassName].join(" ")} title="Fechar"
                  onClick={() => setShow(!show)}>
                {show ? <FaAngleLeft /> : <FaAngleRight />}
            </span>
            {children}
        </div>
    );
};

export default PanelDefault;